export default __webpack_public_path__ + "static/screenshot-90b28d136335a9d02e25feeb7212d7ce.png";